module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    class: 'c-card c-card-chart c-card-chart-' + _vm.getChartType
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline qa-chart-title-header"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "c-card__body qa-chart-description-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.card.description) + "\n\t\t")]), _vm._v(" "), (_vm.dataAvailable) ? _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    ref: "canvas"
  })]) : _c('h2', {
    staticClass: "c-card__body qa-description-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.card_chart.data_not_available')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16dda769"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Chart.vue
// module id = 513
// module chunks = 1